import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  first,
  flatMap,
  groupBy,
  map,
  mergeMap,
  tap,
  toArray
} from 'rxjs/operators';
import {
  CategoryItem,
  FiltersComponentInterface,
  FiltersTypeEnum,
  IFilterComboComponent,
  IFilterDateComponent,
  IFilterTextComponent,
  RankSortingLocatorComponent,
  RecordAreasLocatorComponent,
  RecordListLocator,
  RecordsAreaItem,
  RequestedItems,
  ViewDataConfigStruct,
  ViewDataService,
  WaHelperService,
  RecordItem
} from 'world-archery-lib';

import { BaseService } from '../../shared/base.service';
import { WorldRecordsCategoriesComboStore } from 'src/app/common-page-components/stores/filters-store/world-records-combo-store';
import { HttpClient } from '@angular/common/http';
import { TextFilter } from '../../../common-page-components/stores/filters-store/filters-store';
import { GenericNewsStore } from 'src/app/common-page-components/stores/entities-store/generic-news-store';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FiltersWorldRecordsService extends BaseService {
  /**
   * The news store for get the world records news.
   *
   * @memberof FiltersWorldRecordsService
   */
  readonly newsStore = new GenericNewsStore(this.http, environment.news_api.world_records);

  comboCategoryStore = new WorldRecordsCategoriesComboStore('Categories:', 'records-category-combo', this.http);
  comboText = new TextFilter('records-text-filter');
  public readonly filtersType: any = [
    this.comboText.filterInfo,
    this.comboCategoryStore.competitionDisciplinesRef.filterInfo,
    this.comboCategoryStore.individualTeamComboRef.filterInfo,
    this.comboCategoryStore.levelComboRef.filterInfo,
    this.comboCategoryStore.historicalComboRef.filterInfo,
    this.comboCategoryStore.filterInfo

  ];
  constructor(views: ViewDataService, helper: WaHelperService, private http:HttpClient) {
    super(views, helper);
    this.newsStore.requestData({}, false).subscribe();
  }

  /**
   *
   * {@inheritdoc}
   * @returns
   * @memberof FiltersWorldRecordsService
   */
  generateDefaultValues() {
    return;
  }
}
